import { isImageContentType, parseThumbsize, safeDimension } from './attachments';

export const isImageAttachmentForLightbox = (attachment) =>
  isImageContentType(attachment?.metadata?.content_type) && attachment?.variants?.medium;

export const isPdfAttachmentForLightbox = (attachment) =>
  attachment?.metadata?.content_type === 'application/pdf' && attachment?.variants?.medium;

const buildAttachmentLightboxSrcset = (attachment) => {
  const candidates = [
    {
      src: attachment?.variants?.medium?.public_url || null,
      width: safeDimension(attachment?.variants?.medium?.width, null),
    },
    {
      src: attachment?.variants?.large?.public_url || null,
      width: safeDimension(attachment?.variants?.large?.width, null),
    },
  ].filter((candidate) => candidate.src && candidate.width);

  if (candidates.length <= 1) return null;

  return candidates
    .sort((left, right) => left.width - right.width)
    .map((candidate) => `${candidate.src} ${candidate.width}w`)
    .join(', ');
};

// Convert one image attachment into the canonical lightbox slide shape.
const buildImageAttachmentLightboxSlide = (attachment) => {
  if (!isImageAttachmentForLightbox(attachment)) return null;

  const mediumWidth = safeDimension(attachment?.variants?.medium?.width, null);
  const mediumHeight = safeDimension(attachment?.variants?.medium?.height, null);
  const largeWidth = safeDimension(attachment?.variants?.large?.width, null);
  const largeHeight = safeDimension(attachment?.variants?.large?.height, null);
  const metadataWidth = safeDimension(attachment?.metadata?.width, null);
  const metadataHeight = safeDimension(attachment?.metadata?.height, null);
  const thumbsizeDimensions = parseThumbsize(attachment?.metadata?.thumbsize);
  const thumbsizeWidth = thumbsizeDimensions?.width || null;
  const thumbsizeHeight = thumbsizeDimensions?.height || null;
  const src = attachment?.variants?.large?.public_url || attachment?.variants?.medium?.public_url || attachment?.public_url || null;
  const publicUrl = attachment?.public_url || null;
  const width = metadataWidth || largeWidth || mediumWidth || thumbsizeWidth || null;
  const height = metadataHeight || largeHeight || mediumHeight || thumbsizeHeight || null;

  if (!src || !publicUrl || !width || !height) return null;

  return {
    attachmentId: attachment?.id || null,
    contentType: attachment?.metadata?.content_type || null,
    src,
    publicUrl,
    previewSrc: attachment?.variants?.medium?.public_url || attachment?.public_url || null,
    srcset: buildAttachmentLightboxSrcset(attachment),
    alt: attachment?.metadata?.file_name || 'Image',
    width,
    height,
  };
};

const buildPdfAttachmentLightboxSlide = (attachment) => {
  if (!isPdfAttachmentForLightbox(attachment)) return null;

  const pdfUrl = attachment?.public_url || null;
  const previewSrc = attachment?.variants?.medium?.public_url || null;

  if (!pdfUrl || !previewSrc) return null;

  return {
    type: 'pdf',
    attachmentId: attachment?.id || null,
    pdfUrl,
    previewSrc,
    alt: attachment?.metadata?.file_name || 'PDF',
  };
};

export const buildAttachmentLightboxSlide = (attachment) =>
  buildImageAttachmentLightboxSlide(attachment) || buildPdfAttachmentLightboxSlide(attachment);
